/**
 * depositBreakdown — shared selector (FE-1, S2 drill-downs). THE single home
 * of the "deposit held" rule on the frontend: settlement-window statuses
 * (ADMITTED / DISCHARGE_INITIATED / BILLING_CLEARANCE) with a positive NET
 * `deposit_total_paise`. Mirrors the backend BE-1 #2 rule 1:1 (same status
 * set, same field) so the dashboard tile (server `deposit_held_paise`) and
 * this modal's subtotal can be proven equal on the same seed — see the
 * reconcile-invariant test in `depositBreakdown.test.js`.
 *
 * Consumes `isInSettlementWindow` from `constants/admission.js` — never
 * re-lists the 3 status codes here.
 */
import { isInSettlementWindow } from '../../constants/admission';

/**
 * @param {Array<{status: string, deposit_total_paise: number}>} rows admission rows (any shape from listAdmissions)
 * @returns {{ rows: Array, total_paise: number }} settlement-window rows with
 *   held > 0, sorted highest-held-first, plus their sum (NET, matches the
 *   server's `deposit_held_paise` field for the same input set).
 */
export function buildDepositHeld(rows) {
  const held = (rows || [])
    .filter((r) => isInSettlementWindow(r?.status) && Number(r?.deposit_total_paise) > 0)
    .map((r) => ({ ...r, deposit_total_paise: Number(r.deposit_total_paise) }))
    .sort((a, b) => b.deposit_total_paise - a.deposit_total_paise);
  const total_paise = held.reduce((sum, r) => sum + r.deposit_total_paise, 0);
  return { rows: held, total_paise };
}
